// extracted by mini-css-extract-plugin
export default {"newsletter":"newsletter--RbIlh","newsletterTitle":"newsletterTitle--F6XOh","form":"form--YMXy1","input":"input--PZrDx","button":"button--IO4iH"};